import router from './assign.router'

export default { router }
